import {Outlet, useLoaderData, useLocation} from 'react-router-dom';
import {BenefitShareNavbar} from '../../blocks/navbar/Navbar';
import {useEffect} from "react";

export default function Layout() {
    const location = useLocation(); // Az aktuális route változásait figyeljük
    const data = useLoaderData();
    useEffect(()=>{
        const script = document.createElement('script');
        script.src = "/benefitshare/js/main.js";
        document.body.appendChild(script);

        // Scroll reset: az oldal tetejére ugrunk
        window.scrollTo(0, 0);

        return () => {
            document.body.removeChild(script);
        };
    },[location.pathname])

    return (
        <div key={location.pathname}>
            <BenefitShareNavbar /> {/* A felhasználó átadása a Navbar-nek */}
            <main>
                <Outlet context={data}/> {/* Itt jelennek meg a gyermek oldalak */}
            </main>
        </div>
    );
}
